/* LogoutSectionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./LogoutSectionRenderer");
const _ = require("lodash");

class LogoutSectionComponent extends EventEmitter {
    constructor(logger, docsService) {
        super();
        this._logger = logger;
        this._renderer = new Renderer(this);
        this._docsService = docsService;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _getDetails(type) {
        let meth = "get" + type;
        // console.log(this._docsService[meth]({}));
        return this._docsService[meth]({})
            .then((data) => data.content)
            .catch((err) => {
                this._logger.error(err);
                return "<div class='error-msg'>Unable to load. Please try again later.</div>";
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        return this._renderer
            ._shutdown()
            .then(() => {
                this._renderer = undefined;
                this._logger = undefined;
            })
            .catch((err) =>
                this._logger.warn({error: err}, "Error shutting down LoginSectionComponent:")
            );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    get content() {
        return this.getContent();
    }

    getContent() {
        return Promise.resolve()
            .then(() => {
                let version = this.getVersion();
                let eula = this.getEula();
                let terms = this.getTermsOfService();
                let privacy = this.getPrivacyPolicy();
                return Promise.all([version, eula, terms, privacy]);
            })
            .then((results) => {
                return [
                    {title: `&copy; ${new Date().getFullYear()} Gluware, Inc.`},
                    {title: results[0]}, // version
                    {title: "Privacy", details: results[3]},
                    {title: "Terms", details: results[2]},
                    {title: "EULA", details: results[1]},
                ];
            })
            .catch((err) => {
                console.log("Rejecting getContent promise", err);
                throw err;
            });
    }

    get privacyPolicy() {
        return this.getPrivacyPolicy();
    }

    getPrivacyPolicy() {
        return this._getDetails("PrivacyPolicy");
    }

    get termsOfService() {
        return this.getTermsOfService();
    }

    getTermsOfService() {
        return this._getDetails("TermsOfService");
    }

    get eula() {
        return this.getEula();
    }

    getEula() {
        return this._getDetails("Eula");
    }

    get version() {
        return this.getVersion();
    }

    getVersion() {
        return this._docsService
            .getVersion({})
            .then((VersionObj) => {
                let versionString = "v2.X.X";
                let parsedVersionObj = JSON.parse(VersionObj);
                if (!_.isEmpty(VersionObj)) {
                    let dateString = Date.create(
                        parsedVersionObj.gluware_version.lastUpdated
                    ).format();
                    versionString =
                        "v" + parsedVersionObj.gluware_version.semver + " (" + dateString + ")";
                }
                return versionString;
            })
            .catch((err) => {
                this._logger.error(err, "Error getting system info version.");
                return "v2.X.X";
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

LogoutSectionComponent.$inject = ["$teve.logger", "$teve.services.Docs"];

module.exports = LogoutSectionComponent;
